import React, { ReactElement, useEffect, useCallback, useState } from 'react'
import WebSettingsCard from 'live/components/ui/admin/web-settings-card'
import { useWebSettingsState } from 'live/settings/useWebSettingsState'
import FormGroup from 'live/components/forms/ui/form-group'
import i18n from 'live/services/i18n'
import { getGlobalConfig, updateGlobalConfig } from '../api/pdf/globalConfig'
import ActionToggle from 'live/components/ui/action-toggle'
export interface PLOT_AREA_GLOBAL_SETTINGS {
    MAX_TICKS_PER_CROP: number
    MAX_TICKS_PER_CROP_ERROR: number
    USE_CROPS: boolean
    RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD: boolean
}

const persist = async (config: PLOT_AREA_GLOBAL_SETTINGS) => {
    return await updateGlobalConfig(config)
}

function AdminSettings(): ReactElement {
    const [currentState, setCurrentState] = useState<{
        loaded: boolean
        config: PLOT_AREA_GLOBAL_SETTINGS
    }>({
        loaded: false,
        config: null
    })

    const { state, actions } = useWebSettingsState<PLOT_AREA_GLOBAL_SETTINGS>(currentState.config)

    useEffect(() => {
        getGlobalConfig().then(currentGlobalValues => {
            setCurrentState({
                loaded: true,
                config: currentGlobalValues
            })
            actions.setPersistedData(currentGlobalValues)
        })
    }, [])

    return (
        <WebSettingsCard
            name="plugin-plot-area-settings"
            className="live-feature mb-15"
            open={state.open}
            error={state.submitted ? state.error : null}
            saved={state.open && state.saved}
            save={() => {
                setCurrentState(({ config }) => ({
                    loaded: false,
                    config
                }))
                persist(currentState.config).then(() => {
                    setCurrentState(({ config }) => ({
                        loaded: true,
                        config
                    }))
                    actions.saveSuccess(currentState.config)
                })
            }}
            toggle={actions.toggle}
            onCancel={() => {
                setCurrentState({
                    config: state.persistedData,
                    loaded: true
                })
            }}
        >
            {currentState.loaded ? (
                <>
                    <div className="live-feature__header">
                        <h2 className="flex-1">{i18n('Export PDF Plot Area Settings')}</h2>
                    </div>
                    <div className="live-feature__header">
                        <h3 className="flex-1">{i18n('Max inch per Print Screen')}</h3>
                    </div>
                    <FormGroup
                        help={
                            <span>
                                {i18n('inches is equals a ticks interval')}
                                <br />
                                {i18n('(100 recommended)')}
                            </span>
                        }
                        value={currentState.config.MAX_TICKS_PER_CROP}
                        hideInput={!state.open}
                        onChange={({ target }) => {
                            setCurrentState(s => ({
                                ...s,
                                config: {
                                    ...s.config,
                                    MAX_TICKS_PER_CROP: parseInt(target.value)
                                }
                            }))
                        }}
                        type="number"
                        step="1"
                        min="10"
                        max="120"
                    />
                    <div className="form-group">
                        <label>{'label'}</label>
                        <ActionToggle
                            onChange={() => {
                                setCurrentState(s => ({
                                    ...s,
                                    config: {
                                        ...s.config,
                                        RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD: !s.config
                                            .RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD
                                    }
                                }))
                            }}
                            elLeft={<span>on</span>}
                            elRight={<span>off</span>}
                            active={currentState.config.RENDER_ON_OPEN_MODAL_EXPORT_DASHBOARD == true}
                            disabled={!state.open}
                        />
                    </div>
                </>
            ) : (
                <div>
                    <i className="fas fa-spinner fa-pulse" />
                </div>
            )}
        </WebSettingsCard>
    )
}

export default {
    persist: persist,
    configComponent: AdminSettings,
    section: i18n('Widget export'),
    name: i18n('Export PDF Plot Area Settings')
}
